import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {APIError} from 'data/errors/api-error';
import {GetHistoryYears, GetHistoryYearsModel, GetHistoryYearsParams} from 'domain/usecases';

export class RemoteGetHistoryYears implements GetHistoryYears {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<GetHistoryYearsModel>,
	) {}

	async get(params: GetHistoryYearsParams): Promise<GetHistoryYearsModel> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'get',
			params: {
				showCurrentYear: params.isShowCurrentYear,
			},
			signal: params.signal,
		});
		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
